import application from './application.js'
import breadcrumbsList from './breadcrumbs.js'
import { combineReducers } from 'redux'
import configuration from './configuration.js'
import jobs from './jobs.js'
import proposalInfo from './proposalInfo'
import proposals from './proposals.js'
import sessions from './sessions.js'
import user from './keycloak.js'

export default combineReducers({
  user,
  breadcrumbsList,
  sessions,
  configuration,
  application,
  proposals,
  jobs,
  proposalInfo,
})
